import { set as setLocalStorage, get as getLocalStorage } from 'local-storage';

const TOOLTIP_STORAGE_KEY = 'tooltipDismissals';

export const useTooltipLocalStorage = (tooltipKey: string) => {
  const getAllGlobalBanners = () =>
    JSON.parse(getLocalStorage(TOOLTIP_STORAGE_KEY));

  const dismissTooltip = () => {
    setLocalStorage(
      TOOLTIP_STORAGE_KEY,
      JSON.stringify({ ...getAllGlobalBanners(), [tooltipKey]: true }),
    );
  };

  const isTooltipDismissed = () => getAllGlobalBanners()?.[tooltipKey] ?? null;

  return {
    isTooltipDismissed,
    dismissTooltip,
  };
};
